//Maybe create sync modal as seperate component for clarity if needed

import { useState } from 'react';
import { HiOutlineUserCircle } from 'react-icons/hi2';
import DataSyncModal from './DataSyncModal';
import { Profilo } from '../pages/Profilo';
import { useNavigate } from 'react-router-dom';
import { knowAcces } from '../utils/utils';
import api from '../api/api';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { getAppUrl } from '../utils/appUrl';

export const UserProfile = ({ onDark = false }) => {
	const navigate = useNavigate();
	const [visible, setVisible] = useState(false);
	const [isSyncModal, setIsSyncModal] = useState(false);
	const [profilo,setProfilo] = useState(false)
	const ghostBy = localStorage.getItem('ghostBy');

	const handleLogout = async () => {
		try {
			await api.get('/logout');
		} catch {
			// ignora errori nella chiamata
		}
		['accessToken', 'username', 'permission', 'pic', 'id', 'cpt_auth', 'ghostBy'].forEach(k => localStorage.removeItem(k));
		navigate('/');
	};

	const restoreAdmin = async () => {
		const { data } = await api.post('/utenti/ghost-login/restore');
		localStorage.setItem('username', data.username);
		localStorage.setItem('accessToken', data.accessToken);
		localStorage.setItem('permission', data.permission || '');
		localStorage.setItem('id', data.id);
		localStorage.setItem('cpt_auth', data.auth_cpt);
		if (data.pic) localStorage.setItem('pic', data.pic); else localStorage.removeItem('pic');
		localStorage.removeItem('ghostBy');
		window.location.href = getAppUrl(data.landingPage || '/Home');
	};



	const rawPic = localStorage.getItem("pic");
	const profilePic =
		rawPic && rawPic !== "null" && rawPic !== "undefined" ? rawPic : null;

	return (
		<>
		<Profilo open={profilo} closeButton={() => setProfilo(false)}/>
			<ClickAwayListener onClickAway={() => setVisible(false)}>
			<div className='relative'>
			{profilePic ?    <img
        alt="user 2"
        src={profilePic}
        className={`h-8 w-8 cursor-pointer rounded-full ${onDark ? 'text-white' : 'dark:text-slate-200 text-miller-300'}`}
		onClick={() => setVisible((value) => !value)}
    />:<HiOutlineUserCircle
					className={`h-8 w-8 cursor-pointer ${onDark ? 'text-white' : 'dark:text-slate-200 text-miller-300'}`}
					onClick={() => setVisible((value) => !value)}
				/>}
				<ul
					className={`absolute right-0 top-10 z-[220] h-fit min-w-44 flex-col rounded-lg border border-slate-300 bg-white py-2 text-sm font-medium text-slate-800 shadow-2xl ${
						visible ? '' : 'hidden'
					}`}
				>
					<a onClick={() => { setVisible(false); setProfilo(!profilo); }} className='flex items-start justify-center md:justify-start py-2 space-x-3 rounded-md  hover:bg-slate-200 cursor-pointer px-5'>
						Profilo
					</a>
					{ghostBy && <a onClick={restoreAdmin} className='flex cursor-pointer items-start justify-center rounded-md px-5 py-2 text-amber-700 hover:bg-amber-50 md:justify-start'>Torna come {ghostBy}</a>}
					{knowAcces(["admin", "team_leader"]) && (
						<a
							className='flex items-start justify-center md:justify-start py-2 space-x-3 rounded-md  hover:bg-slate-200 cursor-pointer px-5'
							onClick={() => { setVisible(false); setIsSyncModal(true); }}
						>
							Sincronizza dati
						</a>
					)}
					<a className='flex items-start justify-center md:justify-start py-2 space-x-3 rounded-md  hover:bg-slate-200 cursor-pointer px-5' onClick={handleLogout}>
						Logout
					</a>
				</ul>
			</div>
			</ClickAwayListener>
			<DataSyncModal
				isOpen={isSyncModal}
				closeButton={() => setIsSyncModal(false)}
			/>
		</>
	);
};
